import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { JwtService } from 'src/app/auth/services';
import { DataService, SharedService } from '../../services';
import { User} from '../../../auth/models';
import { LookupCategory } from 'src/app/shared/enums/EnumsVMS';
import { ILookupCategory } from '../../models/lookup.model';
@Component({
  selector: 'app-navmenu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.scss']
})
export class NavmenuComponent implements OnInit {
  currentUser;
  loggedInUserName;
  show: boolean = false;
  userRole: any;
  role: string;
  loggedInUserProfileId: any;
  isAdminMenuVisible: boolean;
  isVendorAdmin: boolean;
  isRateApporvalMenuVisible:boolean = true;
  loggedInUserProfile: User;
  rateApprovalUsersList: ILookupCategory[];
  vendorOnboardProcessDocTemplateApprovalUsersList: ILookupCategory[];
  isVendorOnboardProcessSearchMenuVisible:boolean = true;
  constructor( private router:Router,
    private storage: LocalStorageService,
    private dataService: DataService,
    private jwtService:JwtService,
    public sharedService: SharedService ) { 
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
         if ((event['url'] == '/login') || (event['url'] == '/')) {
          this.show = false;
         }
         else {
           this.show = true;
           this.getLoggedInUserProfileId();
           this.checkRateApprovalUser();
           this.checkVendorOnboardProcessDocTemplateApprovalUser();
           //  this.profileUserName = 'superadmin';
           this.role = this.jwtService.getRoles();
           this.currentUser = this.storage.retrieve('currentuser');
          
           if(this.currentUser != null) {
             this.loggedInUserName = this.currentUser.firstName;
           } 
         }
        }
    });
  }
  
  getLoggedInUserProfileId()
  {
    this.loggedInUserProfileId = this.sharedService.getLoggedInUserProfileId();
    if(this.loggedInUserProfileId <= 0 || this.loggedInUserProfileId == undefined|| this.loggedInUserProfileId == null)
    {
      /*console.log('this.loggedInUserProfileId');
      console.log(this.loggedInUserProfileId);*/
      this.show = false;
    //  this.router.navigateByUrl('/login');
    }
    else{
      var loggedInUserRole = this.sharedService.getLoggedInUserRoles();
      if(loggedInUserRole == "Super Admin" || loggedInUserRole == "Admin" || loggedInUserRole == "VMS ANalyst")
      {
        this.isAdminMenuVisible = true;
      }else{
        this.isAdminMenuVisible = false;
      }

      if(loggedInUserRole=="Vendor Admin")
      {
        this.isVendorAdmin==true;
      }
    }
    
  }

  ngOnInit() {
    //location.reload()
    this.checkRateApprovalUser();
    this.checkVendorOnboardProcessDocTemplateApprovalUser();
  }
  checkRateApprovalUser() {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.RateApprovalUsers).subscribe((data: any) => {
    this.rateApprovalUsersList = data;
   //console.log(this.rateApprovalUsersList);
   // console.log(this.rateApprovalUsersList.description.indexOf(this.loggedInUserProfile.sub));
    var tmprateApprovalUsers = this.rateApprovalUsersList.findIndex(t=>t.description==this.loggedInUserProfile.sub);
  
   
  // console.log(tmprateApprovalUsers);
  // console.log(this.loggedInUserProfile.sub);
    if(tmprateApprovalUsers<0) {
      this.isRateApporvalMenuVisible = false;
    } else {
      this.isRateApporvalMenuVisible = true;
    }
    
  });
  }

  checkVendorOnboardProcessDocTemplateApprovalUser() {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.VendorOnboardProcessDocTemplateApproveUsers).subscribe((data: any) => {
    this.vendorOnboardProcessDocTemplateApprovalUsersList = data;
    //console.log(this.vendorOnboardProcessDocTemplateApprovalUsersList);
    //console.log(this.vendorOnboardProcessDocTemplateApprovalUsersList.description.indexOf(this.loggedInUserProfile.sub));
    var tmpVendorOnboardDocTemplateApprovalUsers = this.vendorOnboardProcessDocTemplateApprovalUsersList.findIndex(t=>t.description==this.loggedInUserProfile.sub);
    //console.log(tmpVendorOnboardDocTemplateApprovalUsers);
    //console.log(this.loggedInUserProfile.sub);
    if(tmpVendorOnboardDocTemplateApprovalUsers<0) {
      this.isVendorOnboardProcessSearchMenuVisible = false;
    } else {
      this.isVendorOnboardProcessSearchMenuVisible = true;
    }
    
  });
  }

}
